import { ClickAwayListener, List, ListItem, ListItemIcon, Paper, makeStyles } from "@material-ui/core";
import { Close, People, Refresh } from "@material-ui/icons";
import * as React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    background: "#ffffff",
    lineHeight: "initial",
    position: "absolute" as "absolute",
    right: 0,
    top: "100%",
    zIndex: 1
  },
  listItem: {
    whiteSpace: "nowrap" as "nowrap"
  }
});

interface IOwnProps {
  onCancel: (talkId?: string) => void;
  onReassign: (talkId?: string, cycleId?: string) => void;
  onReopen: (talkId?: string) => void;
  talkId?: string;
  cycleId: string;
  open: boolean;
  onClose: () => void;
  cancelDisabled?: boolean;
  reassignDisabled?: boolean;
  reopenDisabled?: boolean;
  showCancel: boolean;
  showReasign: boolean;
  showReopen: boolean;
}

const EmployeeCardOptions = ({
  open,
  onClose,
  onCancel,
  talkId,
  cycleId,
  cancelDisabled = false,
  reassignDisabled = false,
  reopenDisabled = false,
  showCancel,
  showReasign,
  onReassign,
  onReopen,
  showReopen
}: IOwnProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleCancel = React.useCallback(() => {
    if (talkId) {
      onCancel(talkId);
    } else {
      // talkId is not passed when this component is used on cycle participant dashboard
      onCancel();
    }
  }, [talkId, onCancel]);

  const handleReassign = React.useCallback(() => {
    if (talkId) {
      onReassign(talkId, cycleId);
    } else {
      // talkId is not passed when this component is used on cycle participant dashboard
      onReassign();
    }
  }, [talkId, cycleId, onReassign]);

  const handleReopen = React.useCallback(() => {
    if (talkId) {
      onReopen(talkId);
    } else {
      // talkId is not passed when this component is used on cycle participant dashboard
      onReopen();
    }
  }, [talkId, onReopen]);

  if (!open) {
    return null;
  }

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper className={classes.container}>
        <List>
          {showReasign ? (
            <ListItem
              disabled={reassignDisabled}
              onClick={handleReassign}
              button
              className={classes.listItem}
              data-qa-selector="reassign-selector"
            >
              <ListItemIcon>
                <People />
              </ListItemIcon>
              {t("feedback.page.my-employees.options.reassign")}
            </ListItem>
          ) : null}
          {showCancel ? (
            <ListItem
              disabled={cancelDisabled}
              onClick={handleCancel}
              button
              className={classes.listItem}
              data-qa-selector="cancelTalk-selector"
            >
              <ListItemIcon>
                <Close />
              </ListItemIcon>
              {t("feedback.page.my-employees.options.cancelTalk")}
            </ListItem>
          ) : null}
          {showReopen ? (
            <ListItem
              disabled={reopenDisabled}
              onClick={handleReopen}
              button
              className={classes.listItem}
              data-qa-selector="reopenTalk-selector"
            >
              <ListItemIcon>
                <Refresh />
              </ListItemIcon>
              {t("feedback.page.my-employees.options.reopenTalk")}
            </ListItem>
          ) : null}
        </List>
      </Paper>
    </ClickAwayListener>
  );
};

export default React.memo(EmployeeCardOptions);
